var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleFillWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 3.5C14.4703 3.5 3.5 14.4703 3.5 28C3.5 41.5297 14.4703 52.5 28 52.5C41.5297 52.5 52.5 41.5297 52.5 28C52.5 14.4703 41.5297 3.5 28 3.5ZM37.0453 37.3078L33.4359 37.2914L28 30.8109L22.5695 37.2859L18.9547 37.3023C18.7141 37.3023 18.5172 37.1109 18.5172 36.8648C18.5172 36.7609 18.5555 36.6625 18.6211 36.5805L25.7359 28.1039L18.6211 19.6328C18.555 19.5527 18.5183 19.4523 18.5172 19.3484C18.5172 19.1078 18.7141 18.9109 18.9547 18.9109L22.5695 18.9273L28 25.4078L33.4305 18.9328L37.0398 18.9164C37.2805 18.9164 37.4773 19.1078 37.4773 19.3539C37.4773 19.4578 37.4391 19.5563 37.3734 19.6383L30.2695 28.1094L37.3789 36.5859C37.4445 36.668 37.4828 36.7664 37.4828 36.8703C37.4828 37.1109 37.2859 37.3078 37.0453 37.3078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleFillWhite);
export default __webpack_public_path__ + "static/media/close-circle-fill-white.cd57dc77acbbe599ce2b1ce84a4fde30.svg";
export { ForwardRef as ReactComponent };